// Figures as the interface writes them (design system, "Numbers"): «.» for thousands, «,» for
// decimals, at most one decimal, and production always per minute («40/min»).
import { formatNumber } from './dom';

/** An amount or rate with at most one decimal, dropping «,0». */
export function fmt(n: number): string {
  const rounded = Math.round(n * 10) / 10;
  return formatNumber(Object.is(rounded, -0) ? 0 : rounded, Number.isInteger(rounded) ? 0 : 1);
}

export const perMinute = (n: number): string => `${fmt(n)}/min`;

/** A share from 0 to 1 as a percentage with a space: «62 %». */
export const percent = (share: number): string => `${Math.round(share * 100)} %`;
